const ITEMS = ["ACRYLIC", "PVC", "WOOD", "METAL", "FOAM", "ACM", "VINYL", "LED", "3D"];

export default function MaterialsStrip() {
  return (
    <section
      data-testid="materials-marquee-section"
      aria-hidden="true"
      className="overflow-hidden border-y border-white/10 bg-ink py-6 lg:py-8"
    >
      <div className="animate-marquee flex w-max items-center whitespace-nowrap">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center">
            {ITEMS.map((item) => (
              <span
                key={`${dup}-${item}`}
                className="flex items-center font-display text-3xl font-extrabold uppercase tracking-tight text-paper/90 sm:text-4xl lg:text-5xl"
              >
                {item}
                <span className="mx-6 text-acid lg:mx-10">×</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
